<template>
  <v-card border>
    <v-card-title class="ws-normal">
      <v-row
        class="p-0 mb-1"
        dense
      >
        <v-col
          v-if="course?.image_url || course?.labels.length > 0"
          class="position-relative"
          cols="12"
        >
          <v-img
            :height="course.image_url ? 250 : 30"
            :src="course.image_url"
            alt=""
          />

          <v-chip-group class="bottom-0 position-absolute">
            <v-chip
              v-for="label in course.labels"
              :key="label.id"
              class="bg-grey-lighten-5 oo--1"
            >
              {{ $bct(label.name) }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>

      <div class="h-100 line-clamp-2">
        {{ $bct(course.name) }}
      </div>
    </v-card-title>

    <v-card-text>
      <div
        v-if="course.description"
        class="fs-16 fw-500 mb-2 h-100 line-clamp-3"
      >
        {{ $bct(course.description) }}
      </div>

      <div class="d-flex align-start">
        <div class="me-3">
          <v-progress-circular
            :model-value="courseCompletion.progress"
            color="primary"
            rotate="-90"
            size="70"
            width="10"
          >
            <div class="fs-16 fw-600">
              {{ `${courseCompletion.progress}%` }}
            </div>
          </v-progress-circular>
        </div>

        <div>
          <div class="fs-20 fw-500 mb-1">
            {{ courseCompletion.count_of_lesson_completions }} / {{ course.count_of_lessons }}
            {{ $bct('Lessons completed') }}
          </div>

          <div class="fs-22 d-flex align-center">
            <template v-if="courseCompletion.completed_at">
              <v-icon
                class="me-2"
                color="primary"
                icon="verified"
                size="28"
              />
              <span class="fw-600 fs-18">{{ $bct('Completed') }}</span>
            </template>

            <template v-else>
              <v-icon
                class="me-2"
                color="primary"
                icon="radio_button_unchecked"
                size="28"
              />

              <span class="fs-18">
                {{ $bct(courseCompletion.progress > 0 ? 'In progress' : 'Not started') }}
              </span>
            </template>
          </div>
        </div>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        :ripple="false"
        :to="{
          name: 'CourseShow',
          params: { courseId: course.id },
        }"
        append-icon="east"
        color="primary"
        size="x-large"
        block
      >
        <span v-if="courseCompletion.progress == 0">
          {{ $bct('Get started') }}
        </span>
        <span v-else-if="courseCompletion.progress == 100">
          {{ $bct('Download certificate') }}
        </span>
        <span v-else>
          {{ $bct('Continue') }}
        </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  course: {
    type: Object,
    default: null,
  },
  courseCompletion: {
    type: Object,
    default() {
      return {
        progress: 0,
        count_of_lesson_completions: 0,
      };
    },
  },
});
</script>

<style scoped>
.ws-normal {
  white-space: normal;
}
.oo--1 {
  outline-offset: -1px;
}
.line-clamp-2 {
  max-height: calc(1.25em * 2);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}
.line-clamp-3 {
  line-height: 1.5;
  max-height: calc(1.5em * 3);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}
</style>
